export default __webpack_public_path__ + "static/about-img1-4a3c5f84692d11872a423eee5056ae70.png";